import React, { useState } from 'react'
import { Checkbox, Divider, Spin } from 'antd';
import { useQuery } from 'react-query';
import axios from '../../../utils/AxiosUtil';
import { useSelector } from 'react-redux'
//写标签更简洁
const CheckboxGroup = Checkbox.Group;

/**
 * 新增用户界面 权限设定部分。
 * 函数名首字母大写，是因为在师兄的另一台机器，会验证
 */
export default function UserCheckMenu(props) {

    // console.log('userCheckMenu will query .........', props.roleId);

    let queryKeys;
    let url;
    let queryParams;
    if (props.queryType == 'byRole') {
        let rid = props.roleId;
        queryKeys = ['userCheckMenusByRole', rid];
        url = '/menu/list-by-role';
        queryParams = { roleId: rid };
    } else if (props.queryType == 'byUser') {
        let uid = props.uid;
        queryKeys = ['userCheckMenusByUser', uid];
        url = '/menu/list-by-user';
        queryParams = { uid: uid };
    }
    const { data, isLoading, isError, error } = useQuery(queryKeys,
        () => axios.post('/fund' + url, queryParams), { refetchOnWindowFocus: false, staleTime: 0 });
    // console.log("****data is :", data);
    // console.log("error is :", isError, error);

    let cData = [];

    if (isLoading) {
        return <Spin tip="加载中..." />
    } else if (isError) {
        return <div>加载错误：{error}</div>
    } else {

        let r = { ...data.data };
        if (r.code == 0) {
            // console.log("***用户权限：", r.data);
            //按一级菜单遍历
            r.data.forEach((p, i) => {
                if (p.children) {
                    //有二级菜单

                    let defaultInterminate;//pbox初始显示部分选中
                    let defaultCheckAll;//pbox初始显示全选
                    //菜单组件的数据
                    let c = {
                        withChildren: true,
                        parentName: p.menu_name,
                        en_Name: p.en_menu_name,
                        parentId: p.menu_id,
                        plainOptions: [],//所有呈现的子box
                        defaultCheckedList: [],//初始选中的子box
                        name2IdDict: { [p.menu_name]: p.menu_id }
                    }
                    p.children.forEach((pc, j) => {
                        c.plainOptions.push({ label: pc.menu_name, value: pc.menu_id, en_label: pc.en_menu_name });
                        if ((pc.checked + '') == 'true')
                            c.defaultCheckedList.push(pc.menu_id);
                        //新增字典键值对
                        c.name2IdDict[pc.menu_name] = pc.menu_id;
                    });
                    if (c.defaultCheckedList.length == 0) {
                        defaultInterminate = false;
                        defaultCheckAll = false;
                    } else if (c.plainOptions.length == c.defaultCheckedList.length) {
                        defaultInterminate = false;
                        defaultCheckAll = true;
                    } else {
                        defaultInterminate = true;
                        defaultCheckAll = false;
                    }
                    c.defaultInterminate = defaultInterminate;
                    c.defaultCheckAll = defaultCheckAll;

                    cData.push(c);
                } else {
                    //单独的一级菜单
                    let c = {
                        withChildren: false,
                        parentName: p.menu_name,
                        en_Name: p.en_menu_name,
                        parentId: p.menu_id,
                        name2IdDict: { [p.menu_name]: p.menu_id },
                        checked: (p.checked + '' == 'true') ? true : false,
                    }
                    cData.push(c);
                }
            });

            // console.log("user权限设定props(cData):", cData);
            return (
                <div>
                    {cData.map((cd, i) => {
                        let t = new Date().getTime();
                        if (cd.withChildren) {
                            return <ParentAndChildren {...cd} key={cd.parentName + t} />
                        } else {
                            return <ParentOnly {...cd} key={cd.parentName + t} />
                        }
                    })}
                </div>
            );

        } else {
            // console.log("***用户权限查询失败：", r.data);
            return <div>加载错误：{r.data}</div>
        }
    }



    // return (
    //     <div>
    //         {cData.map((cd, i) => {
    //             if (cd.withChildren) {
    //                 return <ParentAndChildren {...cd} key={i} />
    //             } else {
    //                 return <ParentOnly {...cd} key={i} />
    //             }
    //         })}

    //     </div>
    // );
}

/**
 * 一个一级菜单父勾选框（全选，部分，全不选）+二级菜单子勾选框group
 * plainOptions,所有标签和对应值[{label:'新建票据',value:'A1'},{label:'票据列表',value:'A2'},...]
 * defaultCheckedList,实际勾选。和plainOptions对应。
 */
function ParentAndChildren(props) {
    const { plainOptions, defaultCheckedList, defaultInterminate, defaultCheckAll } = props;
    const [checkedList, setCheckedList] = useState(defaultCheckedList);
    const [indeterminate, setIndeterminate] = useState(defaultInterminate);
    const [checkAll, setCheckAll] = useState(defaultCheckAll);
    const langValue = useSelector(state => state.langList.value)
    //checkbox的切换回调，返回组中选中的标签
    const onChange = list => {
        // console.log("**list:", list);

        setCheckedList(list);
        setIndeterminate(!!list.length && list.length < plainOptions.length);
        setCheckAll(list.length === plainOptions.length);
        // console.log('group change:', indeterminate, checkAll, list);
    };

    const onParentChange = e => {
        //父组件checked，子组件全选；反之，全不选
        let checkAll = e.target.checked;//获取勾选状态

        setCheckedList(checkAll ? plainOptions.map((p) => p.value) : []);
        setIndeterminate(false);//非中间态

        //父组件
        setCheckAll(checkAll);
        // console.log('parent change:', indeterminate, checkAll);
    };
    return (
        <div>
            <Divider style={{ margin: '5px 0' }} />
            <Checkbox indeterminate={indeterminate} onChange={onParentChange}
                checked={checkAll} name="ck-all" value={props.parentId}>
                {langValue == 0 ? (props.parentName + props.en_Name) : (langValue == 1 ? props.parentName : props.en_Name)}
                {/* <input name="ckAll" value={props.parentId} status={indeterminate || checkAll} /> */}
            </Checkbox>
            <span> &nbsp; {'>'} &nbsp; </span>
            <CheckboxGroup name="ck-cld" value={checkedList} onChange={onChange} >
                {plainOptions.map(item => {
                    return <Checkbox value={item.value} key={item.value}>{langValue == 0 ? (item.label + item.en_label) : (langValue == 1 ? item.label : item.en_label)}</Checkbox>
                })}
            </CheckboxGroup>
        </div>
    );
}

/**
 * 单独一级菜单，无子节点
 */
function ParentOnly(props) {
    const langValue = useSelector(state => state.langList.value)
    let onSingleChange = (checked) => {
        // console.log("onSingleChange:", checked);
    }
    return (
        <div>
            <Divider style={{ margin: '5px 0' }} />
            <Checkbox onChange={onSingleChange} defaultChecked={props.checked} name='ck-only' value={props.parentId}
            >
                {langValue == 0 ? (props.parentName + props.en_Name) : (langValue == 1 ? props.parentName : props.en_Name)}
            </Checkbox>

        </div>
    );
}